import { render, staticRenderFns } from "./expert-index.vue?vue&type=template&id=3d28714a&scoped=true"
import script from "./expert-index.vue?vue&type=script&lang=js"
export * from "./expert-index.vue?vue&type=script&lang=js"
import style0 from "./expert-index.vue?vue&type=style&index=0&id=3d28714a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28714a",
  null
  
)

export default component.exports